export default __webpack_public_path__ + "static/Preview-8fb4935d26eae6c4797ed94045376e70.png";